export default {
  resetZoom: 'Obnoviť priblíženie',
  tool: {
    zoomXy: 'Priblíženie',
    zoomX: 'Priblíženie X',
    zoomY: 'Priblíženie Y',
    pan: 'Posúvanie',
  },
};
